/**
 * Labels y badges centralizados para estados y tipos de operaciones.
 *
 * Previamente estos mappings estaban duplicados en 5 archivos
 * (OperacionDetallePage, CompletadasTable, CompletadasRecepcionTable,
 * DashboardPage, AnmatPage, etc.) — cualquier renombre quedaba inconsistente.
 *
 * Esta es la fuente única de verdad para presentación. El UI debe importar
 * de acá; nuevos estados/tipos se agregan acá y la app entera se actualiza.
 */

import type { EstadoAnmat, TipoOperacion } from '../types';

// =============================================================================
// Estados ANMAT
// =============================================================================

export const ANMAT_LABEL: Record<EstadoAnmat, string> = {
  no_informada: 'No informada',
  en_cola: 'En cola',
  informada: 'Informada',
  confirmada: 'Confirmada',
  error: 'Error',
  cancelada: 'Cancelada',
};

/** Clase Tailwind del badge correspondiente a cada estado. */
export const ANMAT_BADGE: Record<EstadoAnmat, string> = {
  no_informada: 'badge-gray',
  en_cola: 'badge-blue',
  informada: 'badge-green',
  confirmada: 'badge-green',
  error: 'badge-red',
  cancelada: 'badge-gray',
};

// =============================================================================
// Tipos de operación
// =============================================================================

export const TIPO_OPERACION_LABEL: Record<TipoOperacion, string> = {
  despacho_transferencia: 'Transferencia',
  despacho_venta: 'Venta',
  despacho_destruccion: 'Destrucción',
  recepcion: 'Recepción',
};

/** Versión extendida con prefijo "Despacho · " para contextos con headers. */
export const TIPO_OPERACION_LABEL_LARGO: Record<TipoOperacion, string> = {
  despacho_transferencia: 'Despacho · Transferencia',
  despacho_venta: 'Despacho · Venta',
  despacho_destruccion: 'Despacho · Destrucción',
  recepcion: 'Recepción',
};

/** Sigla compacta para celdas de tablas (3 letras). */
export const TIPO_OPERACION_SIGLA: Record<TipoOperacion, string> = {
  despacho_transferencia: 'TRS',
  despacho_venta: 'VTA',
  despacho_destruccion: 'DST',
  recepcion: 'REC',
};

/** Badge color para cada tipo de operación. */
export const TIPO_OPERACION_BADGE: Record<TipoOperacion, string> = {
  despacho_transferencia: 'badge-purple',
  despacho_venta: 'badge-blue',
  despacho_destruccion: 'badge-red',
  recepcion: 'badge-orange',
};
